<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!is401 && !is404" title="{{ 'feedback'|translate }}">
        <ng-template #questionComponentRef></ng-template>
    </module-content>
</mobile-page-content>
